import getBodySettings from '../../site/global/page-settings';
import _bundle from '../core--bundles';

export default function() {
    _bundle.add({
        name: 'Test Page Settings',
        event: ['on:BundleReady'],
        fn() {
            const settingsLayout = getBodySettings('layout');
            const settingsEnv = getBodySettings('env');
            const settingsPage = getBodySettings('page');

            Object.keys(settingsLayout).forEach(function(key) {
                $('#page-settings-layout').append(`
                  <li class="flex justify-between">
                    <div class="t-muted">${key}:&nbsp;</div>
                    <div class="t-red">${settingsLayout[key]}</div>
                  </li>`);
            });
            Object.keys(settingsPage).forEach(function(key) {
                $('#page-settings-page').append(`
                  <li class="flex justify-between">
                    <div class="t-muted">${key}:&nbsp;</div>
                    <div class="t-red">${settingsPage[key]}</div>
                  </li>`);
            });
            Object.keys(settingsEnv).forEach(function(key) {
                $('#page-settings-env').append(`
                  <li class="flex justify-between">
                    <div class="t-muted">${key}:&nbsp;</div>
                    <div class="t-red">${settingsEnv[key]}</div>
                  </li>`);
            });
        }
    });
}
